import styles from "./TableCell.module.css";
import cn from "classnames";
import { IconChevronDown } from "src/components/ui-components/Icons/IconChevronDown";
import { IconChevronBarExpand } from "src/components/ui-components/Icons/IconChevronBarExpand";
import { IconButton } from "src/components/ui-components/Button/IconButton";

import { useState } from "react";

import type { Cell } from "react-table";

interface TableCellProps<T extends object> {
  cell: Cell<T>;
}

export const TableCell = <T extends object>(props: TableCellProps<T>) => {
  const { cell } = props;

  if (typeof cell.value === "string" && cell.value.includes("\n")) {
    return <ExpandableTableCell cell={cell} />;
  }

  return <td {...cell.getCellProps()}>{cell.render("Cell")}</td>;
};

const ExpandableTableCell = <T extends object>({ cell }: TableCellProps<T>) => {
  const [isExpanded, setIsExpanded] = useState(false);
  const toggleExpanded = () => setIsExpanded((b) => !b);

  return (
    <td {...cell.getCellProps()}>
      <div className={cn(styles.withButton, isExpanded && styles.expandLines)}>
        <IconButton
          size="XS"
          theme="ghost"
          aria-label={isExpanded ? "collapse" : "expand"}
          onClick={toggleExpanded}
        >
          {isExpanded ? <IconChevronDown /> : <IconChevronBarExpand />}
        </IconButton>

        {cell.render("Cell")}
      </div>
    </td>
  );
};
